import React from "react";
import "../css/privacy.scss";

function IntellectualProperty() {
  return (
    <main className="ip-policy policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">IP &amp; Takedown Policy</h1>
        <div className="policy-content">
          <p>Uightparcel respects copyright, trade marks, design rights, publicity rights and other intellectual property. This page explains how to report material on uightparcel.shop that you believe affects your rights.</p>

          <h2>How to send a notice</h2>
          <p>Email <a href="mailto:track@uightparcel.shop?subject=Intellectual%20property%20notice">track@uightparcel.shop</a> and include:</p>
          <ol>
            <li>Your name and reliable contact details.</li>
            <li>The right or protected work you believe is affected, with evidence of ownership or authority to act.</li>
            <li>The exact site URL and a clear description of the material in question.</li>
            <li>Why you believe the use is unauthorised or unlawful.</li>
            <li>A statement that the information supplied is accurate and provided in good faith.</li>
          </ol>

          <h2>What happens next</h2>
          <p>We will review sufficiently detailed notices and may temporarily restrict material while investigating. We may ask for more information, contact the person who supplied the material, remove or replace it, or decline a request where we reasonably believe the use is authorised or the notice is incomplete.</p>

          <h2>Good-faith reports</h2>
          <p>Please do not knowingly make false claims. This process is for rights concerns and is not a substitute for legal advice or formal legal procedures available in your jurisdiction.</p>

          <h2>Current visual policy</h2>
          <p>The published site currently uses newly generated AI product visuals based on generic product specifications, without third-party branding. Previously supplied photography remains outside the public site pending source and licence verification.</p>
        </div>
      </div>
    </main>
  );
}

export default IntellectualProperty;
